// Region/subdivision data for UI::Form::RegionSelect
// Regions use ISO 3166-2 codes, keyed by ISO 3166-1 alpha-3 country codes

const REGIONS = {
  "USA": {
    "US-AL": "Alabama",
    "US-AK": "Alaska",
    "US-AZ": "Arizona",
    "US-AR": "Arkansas",
    "US-CA": "California",
    "US-CO": "Colorado",
    "US-CT": "Connecticut",
    "US-DE": "Delaware",
    "US-FL": "Florida",
    "US-GA": "Georgia",
    "US-HI": "Hawaii",
    "US-ID": "Idaho",
    "US-IL": "Illinois",
    "US-IN": "Indiana",
    "US-IA": "Iowa",
    "US-KS": "Kansas",
    "US-KY": "Kentucky",
    "US-LA": "Louisiana",
    "US-ME": "Maine",
    "US-MD": "Maryland",
    "US-MA": "Massachusetts",
    "US-MI": "Michigan",
    "US-MN": "Minnesota",
    "US-MS": "Mississippi",
    "US-MO": "Missouri",
    "US-MT": "Montana",
    "US-NE": "Nebraska",
    "US-NV": "Nevada",
    "US-NH": "New Hampshire",
    "US-NJ": "New Jersey",
    "US-NM": "New Mexico",
    "US-NY": "New York",
    "US-NC": "North Carolina",
    "US-ND": "North Dakota",
    "US-OH": "Ohio",
    "US-OK": "Oklahoma",
    "US-OR": "Oregon",
    "US-PA": "Pennsylvania",
    "US-RI": "Rhode Island",
    "US-SC": "South Carolina",
    "US-SD": "South Dakota",
    "US-TN": "Tennessee",
    "US-TX": "Texas",
    "US-UT": "Utah",
    "US-VT": "Vermont",
    "US-VA": "Virginia",
    "US-WA": "Washington",
    "US-WV": "West Virginia",
    "US-WI": "Wisconsin",
    "US-WY": "Wyoming",
    "US-DC": "District of Columbia"
  },
  "CAN": {
    "CA-AB": "Alberta",
    "CA-BC": "British Columbia",
    "CA-MB": "Manitoba",
    "CA-NB": "New Brunswick",
    "CA-NL": "Newfoundland and Labrador",
    "CA-NS": "Nova Scotia",
    "CA-ON": "Ontario",
    "CA-PE": "Prince Edward Island",
    "CA-QC": "Quebec",
    "CA-SK": "Saskatchewan",
    "CA-NT": "Northwest Territories",
    "CA-NU": "Nunavut",
    "CA-YT": "Yukon"
  },
  "MEX": {
    "MX-AGU": "Aguascalientes",
    "MX-BCN": "Baja California",
    "MX-BCS": "Baja California Sur",
    "MX-CAM": "Campeche",
    "MX-CHP": "Chiapas",
    "MX-CHH": "Chihuahua",
    "MX-CMX": "Mexico City",
    "MX-COA": "Coahuila",
    "MX-COL": "Colima",
    "MX-DUR": "Durango",
    "MX-GUA": "Guanajuato",
    "MX-GRO": "Guerrero",
    "MX-HID": "Hidalgo",
    "MX-JAL": "Jalisco",
    "MX-MEX": "México",
    "MX-MIC": "Michoacán",
    "MX-MOR": "Morelos",
    "MX-NAY": "Nayarit",
    "MX-NLE": "Nuevo León",
    "MX-OAX": "Oaxaca",
    "MX-PUE": "Puebla",
    "MX-QUE": "Querétaro",
    "MX-ROO": "Quintana Roo",
    "MX-SLP": "San Luis Potosí",
    "MX-SIN": "Sinaloa",
    "MX-SON": "Sonora",
    "MX-TAB": "Tabasco",
    "MX-TAM": "Tamaulipas",
    "MX-TLA": "Tlaxcala",
    "MX-VER": "Veracruz",
    "MX-YUC": "Yucatán",
    "MX-ZAC": "Zacatecas"
  },
  "GBR": {
    "GB-ENG": "England",
    "GB-SCT": "Scotland",
    "GB-WLS": "Wales",
    "GB-NIR": "Northern Ireland"
  },
  "FRA": {
    "FR-ARA": "Auvergne-Rhône-Alpes",
    "FR-BFC": "Bourgogne-Franche-Comté",
    "FR-BRE": "Bretagne",
    "FR-CVL": "Centre-Val de Loire",
    "FR-COR": "Corse",
    "FR-GES": "Grand Est",
    "FR-GUA": "Guadeloupe",
    "FR-GUF": "Guyane",
    "FR-HDF": "Hauts-de-France",
    "FR-IDF": "Île-de-France",
    "FR-MAY": "Mayotte",
    "FR-MTQ": "Martinique",
    "FR-NOR": "Normandie",
    "FR-NAQ": "Nouvelle-Aquitaine",
    "FR-OCC": "Occitanie",
    "FR-PDL": "Pays de la Loire",
    "FR-PAC": "Provence-Alpes-Côte d'Azur",
    "FR-REU": "La Réunion"
  },
  "DEU": {
    "DE-BW": "Baden-Württemberg",
    "DE-BY": "Bayern",
    "DE-BE": "Berlin",
    "DE-BB": "Brandenburg",
    "DE-HB": "Bremen",
    "DE-HH": "Hamburg",
    "DE-HE": "Hessen",
    "DE-MV": "Mecklenburg-Vorpommern",
    "DE-NI": "Niedersachsen",
    "DE-NW": "Nordrhein-Westfalen",
    "DE-RP": "Rheinland-Pfalz",
    "DE-SL": "Saarland",
    "DE-SN": "Sachsen",
    "DE-ST": "Sachsen-Anhalt",
    "DE-SH": "Schleswig-Holstein",
    "DE-TH": "Thüringen"
  },
  "ITA": {
    "IT-ABR": "Abruzzo",
    "IT-BAS": "Basilicata",
    "IT-CAL": "Calabria",
    "IT-CAM": "Campania",
    "IT-EMR": "Emilia-Romagna",
    "IT-FVG": "Friuli-Venezia Giulia",
    "IT-LAZ": "Lazio",
    "IT-LIG": "Liguria",
    "IT-LOM": "Lombardia",
    "IT-MAR": "Marche",
    "IT-MOL": "Molise",
    "IT-PAB": "Piemonte",
    "IT-PUG": "Puglia",
    "IT-SAR": "Sardegna",
    "IT-SIC": "Sicilia",
    "IT-TOS": "Toscana",
    "IT-TAA": "Trentino-Alto Adige",
    "IT-UMB": "Umbria",
    "IT-VDA": "Valle d'Aosta",
    "IT-VEN": "Veneto"
  },
  "ESP": {
    "ES-AN": "Andalucía",
    "ES-AR": "Aragón",
    "ES-AS": "Principado de Asturias",
    "ES-CN": "Canarias",
    "ES-CB": "Cantabria",
    "ES-CM": "Castilla-La Mancha",
    "ES-CL": "Castilla y León",
    "ES-CT": "Cataluña",
    "ES-EX": "Extremadura",
    "ES-GA": "Galicia",
    "ES-IB": "Islas Baleares",
    "ES-RI": "La Rioja",
    "ES-MD": "Madrid",
    "ES-MC": "Región de Murcia",
    "ES-NC": "Comunidad Foral de Navarra",
    "ES-PV": "País Vasco",
    "ES-VC": "Comunidad Valenciana"
  },
  "NLD": {
    "NL-DR": "Drenthe",
    "NL-FL": "Flevoland",
    "NL-FR": "Friesland",
    "NL-GE": "Gelderland",
    "NL-GR": "Groningen",
    "NL-LI": "Limburg",
    "NL-NB": "Noord-Brabant",
    "NL-NH": "Noord-Holland",
    "NL-OV": "Overijssel",
    "NL-UT": "Utrecht",
    "NL-ZE": "Zeeland",
    "NL-ZH": "Zuid-Holland"
  },
  "BEL": {
    "BE-VAN": "Antwerpen",
    "BE-WBR": "Brabant wallon",
    "BE-WHT": "Hainaut",
    "BE-WLG": "Liège",
    "BE-VLI": "Limburg",
    "BE-WLX": "Luxembourg",
    "BE-WNA": "Namur",
    "BE-VOV": "Oost-Vlaanderen",
    "BE-VBR": "Vlaams-Brabant",
    "BE-VWV": "West-Vlaanderen"
  },
  "AUT": {
    "AT-1": "Burgenland",
    "AT-2": "Kärnten",
    "AT-3": "Niederösterreich",
    "AT-4": "Oberösterreich",
    "AT-5": "Salzburg",
    "AT-6": "Steiermark",
    "AT-7": "Tirol",
    "AT-8": "Vorarlberg",
    "AT-9": "Wien"
  },
  "CHE": {
    "CH-AG": "Aargau",
    "CH-AR": "Appenzell Ausserrhoden",
    "CH-AI": "Appenzell Innerrhoden",
    "CH-BL": "Basel-Landschaft",
    "CH-BS": "Basel-Stadt",
    "CH-BE": "Bern",
    "CH-FR": "Fribourg",
    "CH-GE": "Genève",
    "CH-GL": "Glarus",
    "CH-GR": "Graubünden",
    "CH-JU": "Jura",
    "CH-LU": "Luzern",
    "CH-NE": "Neuchâtel",
    "CH-NW": "Nidwalden",
    "CH-OW": "Obwalden",
    "CH-SG": "Sankt Gallen",
    "CH-SH": "Schaffhausen",
    "CH-SZ": "Schwyz",
    "CH-SO": "Solothurn",
    "CH-TG": "Thurgau",
    "CH-TI": "Ticino",
    "CH-UR": "Uri",
    "CH-VS": "Valais",
    "CH-VD": "Vaud",
    "CH-ZG": "Zug",
    "CH-ZH": "Zürich"
  },
  "SWE": {
    "SE-AB": "Stockholms län",
    "SE-AC": "Västerbottens län",
    "SE-BD": "Norrbottens län",
    "SE-C": "Uppsala län",
    "SE-D": "Södermanlands län",
    "SE-E": "Östergötlands län",
    "SE-F": "Jönköpings län",
    "SE-G": "Kronobergs län",
    "SE-H": "Kalmar län",
    "SE-I": "Gotlands län",
    "SE-K": "Blekinge län",
    "SE-M": "Skåne län",
    "SE-N": "Hallands län",
    "SE-O": "Västra Götalands län",
    "SE-S": "Värmlands län",
    "SE-T": "Örebro län",
    "SE-U": "Västmanlands län",
    "SE-W": "Dalarnas län",
    "SE-X": "Gävleborgs län",
    "SE-Y": "Västernorrlands län",
    "SE-Z": "Jämtlands län"
  },
  "NOR": {
    "NO-03": "Oslo",
    "NO-11": "Rogaland",
    "NO-15": "Møre og Romsdal",
    "NO-18": "Nordland",
    "NO-30": "Viken",
    "NO-34": "Innlandet",
    "NO-38": "Vestfold og Telemark",
    "NO-42": "Agder",
    "NO-46": "Vestland",
    "NO-50": "Trøndelag",
    "NO-54": "Troms og Finnmark"
  },
  "DNK": {
    "DK-84": "Hovedstaden",
    "DK-82": "Midtjylland",
    "DK-81": "Nordjylland",
    "DK-85": "Sjælland",
    "DK-83": "Syddanmark"
  },
  "FIN": {
    "FI-01": "Ahvenanmaan maakunta",
    "FI-02": "Etelä-Karjala",
    "FI-03": "Etelä-Pohjanmaa",
    "FI-04": "Etelä-Savo",
    "FI-05": "Kainuu",
    "FI-06": "Kanta-Häme",
    "FI-07": "Keski-Pohjanmaa",
    "FI-08": "Keski-Suomi",
    "FI-09": "Kymenlaakso",
    "FI-10": "Lappi",
    "FI-11": "Pirkanmaa",
    "FI-12": "Pohjanmaa",
    "FI-13": "Pohjois-Karjala",
    "FI-14": "Pohjois-Pohjanmaa",
    "FI-15": "Pohjois-Savo",
    "FI-16": "Päijät-Häme",
    "FI-17": "Satakunta",
    "FI-18": "Uusimaa",
    "FI-19": "Varsinais-Suomi"
  },
  "POL": {
    "PL-DS": "Dolnośląskie",
    "PL-KP": "Kujawsko-pomorskie",
    "PL-LU": "Lubelskie",
    "PL-LB": "Lubuskie",
    "PL-LD": "Łódzkie",
    "PL-MA": "Małopolskie",
    "PL-MZ": "Mazowieckie",
    "PL-OP": "Opolskie",
    "PL-PK": "Podkarpackie",
    "PL-PD": "Podlaskie",
    "PL-PM": "Pomorskie",
    "PL-SL": "Śląskie",
    "PL-SK": "Świętokrzyskie",
    "PL-WN": "Warmińsko-mazurskie",
    "PL-WP": "Wielkopolskie",
    "PL-ZP": "Zachodniopomorskie"
  },
  "PRT": {
    "PT-01": "Aveiro",
    "PT-02": "Beja",
    "PT-03": "Braga",
    "PT-04": "Bragança",
    "PT-05": "Castelo Branco",
    "PT-06": "Coimbra",
    "PT-07": "Évora",
    "PT-08": "Faro",
    "PT-09": "Guarda",
    "PT-10": "Leiria",
    "PT-11": "Lisboa",
    "PT-12": "Portalegre",
    "PT-13": "Porto",
    "PT-14": "Santarém",
    "PT-15": "Setúbal",
    "PT-16": "Viana do Castelo",
    "PT-17": "Vila Real",
    "PT-18": "Viseu",
    "PT-20": "Região Autónoma dos Açores",
    "PT-30": "Região Autónoma da Madeira"
  },
  "IRL": {
    "IE-C": "Connacht",
    "IE-L": "Leinster",
    "IE-M": "Munster",
    "IE-U": "Ulster"
  },
  "GRC": {
    "GR-A": "Anatolikí Makedonía kai Thráki",
    "GR-I": "Attikí",
    "GR-G": "Dytikí Elláda",
    "GR-C": "Dytikí Makedonía",
    "GR-F": "Ionía Nísia",
    "GR-D": "Ípeiros",
    "GR-B": "Kentrikí Makedonía",
    "GR-M": "Kríti",
    "GR-L": "Nótio Aigaío",
    "GR-J": "Pelopónnisos",
    "GR-H": "Stereá Elláda",
    "GR-E": "Thessalía",
    "GR-K": "Vóreio Aigaío"
  },
  "AUS": {
    "AU-ACT": "Australian Capital Territory",
    "AU-NSW": "New South Wales",
    "AU-NT": "Northern Territory",
    "AU-QLD": "Queensland",
    "AU-SA": "South Australia",
    "AU-TAS": "Tasmania",
    "AU-VIC": "Victoria",
    "AU-WA": "Western Australia"
  }
}

export function getRegionsForCountry(countryCode) {
  const regions = REGIONS[countryCode] || {}
  return Object.entries(regions)
    .map(([code, name]) => [name, code])
    .sort(([nameA], [nameB]) => nameA.localeCompare(nameB))
}

export function getPlaceholderForCountry(countryCode) {
  const placeholders = {
    "USA": "Select state...",
    "CAN": "Select province...",
    "MEX": "Select state...",
    "GBR": "Select country...",
    "FRA": "Select region...",
    "DEU": "Select state...",
    "ITA": "Select region...",
    "ESP": "Select autonomous community...",
    "NLD": "Select province...",
    "BEL": "Select province...",
    "AUT": "Select state...",
    "CHE": "Select canton...",
    "SWE": "Select county...",
    "NOR": "Select county...",
    "DNK": "Select region...",
    "FIN": "Select region...",
    "POL": "Select voivodeship...",
    "PRT": "Select district...",
    "IRL": "Select province...",
    "GRC": "Select region...",
    "AUS": "Select state/territory..."
  }

  return placeholders[countryCode] || "Select region..."
}
